import { Folder } from 'lucide-react';
import { Modal } from '../../components/Modal';
import type { FileBrowserTarget } from './FileBrowserModal';
import './folder-picker.css';

export function FolderPicker({ target, onChoose, onClose }: {
  target: FileBrowserTarget;
  onChoose: (pathName: string) => void;
  onClose: () => void;
}) {
  return <Modal title="Выберите папку" onClose={onClose} size="medium" className="sx-folder-picker">
    <p className="sx-folder-picker-asset">{target.title}</p>
    <div className="sx-folder-picker-list">
      {Object.keys(target.paths).map(name => <button type="button" key={name} onClick={() => onChoose(name)}>
        <Folder size={56} strokeWidth={1.5} aria-hidden="true"/>
        <span><strong>{name}</strong></span>
      </button>)}
    </div>
  </Modal>;
}
